import React from 'react';
import { InputWithError, TextInput } from './imports';

export default function GuideSearchInput(props) {
  return (
    <InputWithError
      Type={TextInput}
      name="guideQuery"
      placeholder=" Try 'Everest Base Camp'"
      autocomplete="off"
      {...props}
    />
  )    
};
